<mat-card class="persistent-card" appearance="outlined">
  <mat-card-content [ngClass]="{ faded: loading }">
    <h3>
      <span class="futura-font-ext-bold body-gray">
        {{ selectedAlert.Name }}
      </span>
      <span style="color: lightgray"> ({{ selectedAlert.Id }}) </span>
    </h3>
    <div class="two-column">
      <div class="data">
        <!-- Get Use Case from Int -->
        <!-- <div>
          <span>{{ "COLUMNS.APPLICATION" | translate }}:</span>
          <span *ngIf="!selectedAlert.UseCaseId"> None </span>
          <span *ngIf="selectedAlert.UseCaseId">
            {{ selectedAlert.UseCaseId }}
          </span>
        </div> -->
        <div>
          <span>Triggered By:</span>
          <span *ngIf="!selectedAlert.PersonName"> None </span>
          <span *ngIf="selectedAlert.PersonName">
            {{ selectedAlert.PersonName }}
          </span>
        </div>
        <div>
          <span>Date:</span>
          <span *ngIf="!selectedAlert.EventTime"> None </span>
          <span *ngIf="selectedAlert.EventTime">
            {{ formatTime(selectedAlert.EventTime) }}
          </span>
        </div>
        <div>
          <span>Location:</span>
          <span *ngIf="!selectedAlert.ModelName"> None </span>
          <span *ngIf="selectedAlert.ModelName">
            {{ selectedAlert.ModelName }}
          </span>
        </div>
        <div *ngIf="selectedAlert.ZoneNames">
          <span>{{ "COLUMNS.ZONE" | translate }}:</span>
          <span>{{ selectedAlert.ZoneNames }}</span>
        </div>
        <div *ngIf="selectedAlert.ZoneGroupName">
          <span>{{ "MAPEDITOR.FORM.ZONEGROUP" | translate }}:</span>
          <span>{{ selectedAlert.ZoneGroupName }}</span>
        </div>
      </div>
      <div #mapElement class="mapElement"></div>
    </div>
    <div class="button-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ "MAIN.ALERTS.ACKNOWLEDGEMENT" | translate }}</mat-label>
        <textarea
          matInput
          [placeholder]="'MAIN.ALERTS.LEAVE_A_COMMENT' | translate"
          [(ngModel)]="optionalComment"
        ></textarea>
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="acknowledgeAlert()">
        {{ "FORMS.ACKNOWLEDGE" | translate }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
